<template>
  <div class="container">
    <!-- banner开始 -->
    <div class="banner">
      <div class="icon">
        <img src="@/assets/banner.png" alt="" />
      </div>
      <div class="slogan-text">
        <h1>年盈航空专注差旅服务{{createdYear}}年</h1>
        <p>为政府单位、企业组织节省高达<span>&nbsp;30%</span> 差旅费用</p>
      
      </div>
      <div class="advertise-block">
        <div class="flex-row flex-between centent">
          <p>
            <span>现在咨询&nbsp;&nbsp;欢迎咨询</span>企业差旅管理执行方案一份
          </p>
          <div class="pointer btn" @click="goScroll()">立即咨询</div>
        </div>
      </div>
    </div>
    <!-- banner结束 -->
    <!-- 优质资源开始 -->
    <div class="wealth-block">
      <div class="resource-title">
        <h2>整合全球优质资源, 满足各类差旅需求</h2>
        <p>高效智能 · 专业合规 · 透明节省 · 便捷贴心</p>
      </div>
      <div class="flex-row centent">
        <div class="item">
          <div class="logo">
            <img src="@/assets/flight.png" alt="" />
          </div>
          <p>机票</p>
          <h6>覆盖全球近300多家航空公司</h6>
          <h6>各大航空公司协议价支持在线</h6>
          <h6>预订、退改</h6>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/hotel.png" alt="" />
          </div>
          <p>酒店</p>
          <h6>覆盖全球140万家酒店、国</h6>
          <h6>内100万家酒店国内3000家</h6>
          <h6>酒店协议价、区内400家自</h6>
          <h6>签酒店支持多供应商比价服</h6>
          <h6>务、协议酒店托管</h6>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/travel.png" alt="" />
          </div>
          <p>火车票</p>
          <h6>涵盖高铁、动车、普通列车的</h6>
          <h6>车票查询及预订支持在线选座</h6>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/increment.png" alt="" />
          </div>
          <p>增值服务</p>
          <h6>用车、签证服务、机场服务、</h6>
          <h6>保险、团建旅游、差旅规划咨</h6>
          <h6>询等多种增值服务</h6>
        </div>
      </div>
    </div>
    <!-- 优质资源结束 -->
    <!-- 服务优势开始 -->
    <div class="serve-block">
      <div class="serve-title">
        <h2>服务优势</h2>
        <p>提供一对一 “差旅顾问+客户经理” 双服务体系, 充分保障服务品质</p>
      </div>
      <div class="flex-row flex-between centent-box">
        <div
          class="item"
         @mouseenter="changeActive($event)"
          @mouseleave="removeActive($event)"
        >
          <div class="logo">
            <img src="@/assets/advantage1.png" alt="" />
          </div>
          <p>规模优势</p>
          <span>SCALE ADVANTAGE</span>
          <h6>
            年盈航空成立于2000年，注册资金2000万元人民币，员工100多人，是首批国家财政部指定的“公务机票”销售资质的航空售票公司。
          </h6>
        </div>
        <div
          class="item"
          @mouseenter="changeActive($event)"
          @mouseleave="removeActive($event)"
        >
          <div class="logo">
            <img src="@/assets/advantage2.png" alt="" />
          </div>
          <p>业务优势</p>
          <span>BUSINESS ADVANTAGES</span>
          <h6>
            年盈航空拥有{{createdYear}}年差旅服务经验，整合差旅、会务培训两大业务链，服务于广西、贵州省3000多家党政机关和企事业单位，为超过35万人员提供国际国内机票、火车票、酒店、租车等全方位服务。
          </h6>
        </div>
        <div
          class="item"
          @mouseenter="changeActive($event)"
          @mouseleave="removeActive($event)"
        >
          <div class="logo">
            <img src="@/assets/advantage3.png" alt="" />
          </div>
          <p>服务优势</p>
          <span>SERVICE ADVANTAGES</span>
          <h6>
            年盈航空运营团队共有70多人，平均行业经验5年以上。可通过电话、E-mail、QQ、微信等方式对接，24小时一对一业务顾问，为客户提供更热情、更贴心、更主动、更细心、更专业的高品质服务。
          </h6>
        </div>
        <div
          class="item"
          @mouseenter="changeActive($event)"
          @mouseleave="removeActive($event)"
        >
          <div class="logo">
            <img src="@/assets/advantage4.png" alt="" />
          </div>
          <p>价格优势</p>
          <span>PRICE ADVANTAGES</span>
          <h6>
            年盈航空可协助客户与航空公司及酒店签署大客户协议，并且通过自建的供应商采购平台，以确保我们机票、酒店、签证、用车、旅游产品的价格优势，每年可为客户节省至少20%-30%的差旅费用。
          </h6>
        </div>
        <div
          class="item"
          @mouseenter="changeActive($event)"
          @mouseleave="removeActive($event)"
        >
          <div class="logo">
            <img src="@/assets/advantage5.png" alt="" />
          </div>
          <p>系统优势</p>
          <span>SYSTEM ADVANTAGE</span>
          <h6>
            可通过PC端、APP端、微信公众号、系统OA对接等进行差旅预订。并可根据客户要求设置预订人和出行人的预订权限、审批权限、差旅标准等，满足客户不同需求。
          </h6>
        </div>
      </div>
    </div>
    <!-- 服务优势结束 -->
        <!-- 企业定制开始 -->
    <div class="custom-block">
      <div class="custom-title">
        <h2>企业定制</h2>
        <p>量身定制，全面整合，差旅整体效率提升</p>
      </div>
      <div class="flex-row flex-between details">
        <div class="item">
          <div class="logo">
            <img src="@/assets/custom1.png" alt="" />
          </div>
          <p>支付场景全覆盖</p>
          <h6>月结、预付款、现结等</h6>
          <h6>多种形式可选、贴合客户支付需求</h6>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/custom2.png" alt="" />
          </div>
          <p>系统直连服务</p>
          <h6>打通企业内部OA、HR、财务管理等系统对接</h6>
          <h6>为企业实现一体化预订、审批、报销、结算等闭环操作</h6>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/custom3.png" alt="" />
          </div>
          <p>整合国内外优势资源</p>
          <h6>全面覆盖全球航线资源，140万+国内外酒店资源</h6>
          <h6>；另有签证、火车票、用车、保险等全产品资源覆盖</h6>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/custom4.png" alt="" />
          </div>
          <p>满足多维度合规管控</p>
          <h6>提供定制化的差旅管控方案</h6>
          <h6>智能预订工具，透明的产品价格体系</h6>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/custom5.png" alt="" />
          </div>
          <p>提供数据分析报表</p>
          <h6>专业化的差旅数据分析</h6>
          <h6>保障企业差旅合规透明</h6>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/custom6.png" alt="" />
          </div>
          <p>企业专属差旅服务</p>
          <h6>一对一7*24小时差旅顾问</h6>
          <h6>7*24支持您的差旅需求</h6>
        </div>
      </div>
    </div>
    <!-- 企业定制结束 -->
    <!-- 咨询开始 -->
    <consultView />
    <!-- 咨询结束 -->
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "index",
  data() {
    return {
      createdYear: 0
    };
  },
  created() {
     
  },
  computed: {},
  methods: {
    changeActive(e) {
      e.currentTarget.className = "active";
    },
    removeActive(e) {
      e.currentTarget.className = "item";
    },
    goScroll(){
       document.documentElement.scrollTop=2614;
      window.pageYOffset=2614;
       document.body.scrollTop=2614;
    }
  },
  mounted() {
    this.$emit('childVal', 0);
    let year = dayjs().diff('2000-07-05', 'year', true)
    this.createdYear = Math.floor(year)
  },
  destroy() {
  },
};
</script>
<style lang="less" scoped>
@red: #f65248;
@white: #fff;
@count: 100%;
.seTbtn(@bgColor,@ftColor,@width,@height,@site,@lh,@border,@ftSize) {
  background: @bgColor;
  color: @ftColor;
  width: @width;
  height: @height;
  text-align: @site;
  line-height: @lh;
  border-radius: @border;
  margin: 0 auto;
  font-weight: @ftSize;
}
.banner {
  position: relative;
  width: @count;
  .icon {
    height: 750px;
    img {
      width: @count;
      height: @count;
      object-fit: cover;
    }
  }
  .slogan-text {
    position: absolute;
    margin: 0 auto;
    color: @white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 999;
    h1 {
      font-size: 2rem;
      font-weight: 700;
    }
    p {
      font-size: 1.5rem;
      margin: 40px 0;
      font-weight: 700;
      span {
        font-size: 2rem;
        font-weight: 700;
      }
    }
    .btn {
      display: block;
      .seTbtn(#f65248,#fff,120px,40px,center,40px,2px,700);
    }
  }
  .advertise-block {
    position: absolute;
    bottom: 0;
    left: 0;
    width: @count;
    height: 80px;
    background: rgba(0, 0, 0, 0.4);
    line-height: 80px;
    z-index: 9;
    .centent {
      width: 600px;
      margin: 0 auto;
    }
    p {
      font-size: 0.9rem;
      color: @white;
      span {
        font-weight: 700;
        color: @red;
        padding-right: 20px;
      }
    }
    .btn {
      .seTbtn(#f65248,#fff,120px,40px,center,40px,2px,700);
    }
  }
}
.wealth-block {
  width: @count;
  padding: 70px 0;
  .resource-title {
    width: @count;
    text-align: center;
    margin-bottom: 50px;
    h2 {
      color: #333;
      margin-bottom: 15px;
      font-size: 2rem;
    }
    p {
      font-size: 0.9rem;
      color: #666;
    }
  }
  .centent {
    width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
    justify-content: space-between;
    .item {
      width:19.5%;
      flex: 1;
      text-align: center;
      .logo {
        width: 80px;
        margin: 0 auto;
        img {
          width: @count;
        }
      }
      p {
        font-size: 1.2rem;
        font-weight: 700;
        margin: 20px 0;
      }
      h6 {
        font-size: 0.9rem;
        line-height: 1.2em;
        margin-bottom: 5px;
      }
    }
  }
}
.serve-block {
  padding: 70px 0;
  width: 100%;
  background: url("../../assets/advantage.png") 50%;
  background-size: @count @count;
  .serve-title {
    width: @count;
    text-align: center;
    margin-bottom: 50px;
    h2 {
      margin-bottom: 15px;
      font-size: 2rem;
      color: @white;
    }
    p {
      font-size: 0.9rem;
      color: @white;
    }
  }
  .centent-box {
    width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
    height: 400px;
    .item {
      width: 19.5%;
      height: 300px;
      margin-right: 5px;
      text-align: center;
      background: linear-gradient(180deg, #dd1f1f, #920202);
      color: @white;
      border-radius: 2px;
      transition:width .3s,ease .3s;
      overflow: hidden;
      .logo {
        width: 75px;
        height: 100px;
        margin: 30px auto;
        img {
          width: @count;
        }
      }
      p {
        font-size: 1.6rem;
        font-weight: 700;
        margin-bottom: 10px;
      }
      span {
        font-size: 0.9rem;
      }
      h6 {
        width: 360px;
        height: 0;
        overflow: hidden;
        opacity: 0;
        margin-top: 20px;
        padding: 0 20px;
        line-height: 1.4em;
        font-size: 0.9rem;
        text-align: justify;
        font-weight: 400;
        
      }
    }
  }
}
.active {
  width: 30%;
  height: 380px;
  margin-right: 5px;
  transition:width .3s,ease .3s;
  text-align: center;
  background: #dd1f1f;
  color: @white;
  border-radius: 2px;
  .logo {
    width: 75px;
    height: 100px;
    margin: 30px auto;
    img {
      width: @count;
    }
  }
  p {
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 10px;
  }
  span {
    font-size: 0.9rem;
  }
  h6 {
    width: 360px;
    height: 0;
    margin-top: 20px;
    padding: 0 20px;
    opacity: 1;
    line-height: 1.4em;
    font-size: 0.9rem;
    text-align: justify;
    font-weight: 400;
    opacity: 1;
  }
}
.custom-block {
  width: 100%;
  padding: 70px 0;
  background: #fff;
  .custom-title {
    width: 100%;
    text-align: center;
    margin-bottom: 50px;
    h2 {
      color: #333;
      margin-bottom: 15px;
      font-size: 2rem;
    }
    p {
      font-size: 0.9rem;
      color: #666;
    }
  }
  .details {
    width: 1240px;
    margin: 0 auto;
    flex-wrap: wrap;
    padding: 0 20px;
    .item {
      width: 32%;
      text-align: center;
      margin-bottom: 30px;
      .logo {
        width: 100px;
        margin: 0 auto;
        img {
          width: 100%;
          margin: 0 auto 30px;
        }
      }
      p {
        font-weight: 700;
        font-size: 1.2rem;
        margin-bottom: 20px;
      }
      h6 {
        font-size: 0.9rem;
        margin-bottom: 5px;
        color: #999;
      }
    }
  }
}
</style>